import { useState } from 'react';

import { postOnboardDeviceLogsArchive } from '../api/postOnboardDeviceLogsArchive';
import { downloadFromUrl } from '../utils/downloadFromUrl';

export const useOnboardDeviceLogsArchive = (deviceId: string, onError: (message: string) => void) => {
    const [downloading, setDownloading] = useState(false);

    const downloadLogs = async (logIds: string[]) => {
        if (downloading || logIds.length === 0) {
            return;
        }

        setDownloading(true);

        try {
            const archive = await postOnboardDeviceLogsArchive(deviceId, { logIds });

            downloadFromUrl(archive.downloadUrl, archive.fileName);
        } catch (error: any) {
            console.error('Download error:', error);
            const message = error?.response?.data?.message ?? 'Не вдалося завантажити архів вибраних логів';
            onError(message);
        } finally {
            setDownloading(false);
        }
    };

    return { downloading, downloadLogs };
};
